import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            网友热议
          </h2>
          <p className="text-sm text-foreground-500">看看其他吃瓜群众都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentsData.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-xl p-5 border border-background-200">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-accent-700">{comment.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-heart-line" />
                </span>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}